import { ResourceTypeEnum } from '@/types/schema';

const RECURRING_SESSION_RESOURCE_TYPES = [
  ResourceTypeEnum.RecurringLiveEventContent,
  ResourceTypeEnum.RecurringExternalEventContent,
  ResourceTypeEnum.RecurringOfflineEventContent,
];

export const isRecurringSessionContent = (type?: ResourceTypeEnum) =>
  type && RECURRING_SESSION_RESOURCE_TYPES.includes(type);
